import { Constructor, DoorType, MountType, SystemType } from "../@types/shared";
import {
    CGF300Code,
    CGF350Code,
    CGF400Code,
    CGS200Code,
    KompasDblCode,
    KompasFrameCode,
    KompasFramelessCode,
    KompasSglCode,
    MountPerimeterCode,
    NoDoors,
    NoMountCode,
    RomanoCode,
    SlidingDoors,
    CGFDoors,
    SwingDoors,
    KompasDoors,
    TreviCode,
    SteelSingleSwingDoorCode,
    SteelDoubleSwingDoorsCode,
    SteelSingleSlidingDoorCode,
    SteelDoubleSlidingDoorsCode,
    SteelMultiSlidingDoorsCode,
    SteelFoldingDoorsCode,
    SteelArchSingleSwingDoorCode,
    SteelArchDoubleSwingDoorsCode,
    CGSDoubleSwingDoorsCode,
    CGSSingleSwingDoorCode,
    CGSSingleSlidingDoorCode,
    CGSDoubleSlidingDoorsCode,
} from "../constants";
import { ICreateManyStrategy } from "../domain/strategies/base/creation.strategy";
import {
    CGF300PerimeterSwingDoorHardwaresCreation,
    CGF300PerimeterSlidingDoorHardwaresCreation,
    CGF350PerimeterSwingDoorHardwaresCreation,
    CGF350PerimeterSlidingDoorHardwaresCreation,
    CGF400PerimeterSwingDoorHardwaresCreation,
    CGF400PerimeterSlidingDoorHardwaresCreation,
    CGS200PerimeterSwingDoorHardwaresCreation,
    CGS200PerimeterSlidingDoorHardwaresCreation,
    KompasPerimeterNoDoorHardwaresCreation,
    KompasPerimeterSlidingDoorHardwaresCreation,
    KompasPerimeterSwingDoorHardwaresCreation,
    RomanoNoMountSteelSingleSwingDoorHardwaresCreation,
    RomanoNoMountSteelDoubleSwingDoorHardwaresCreation,
    RomanoNoMountSteelSingleSlidingDoorHardwaresCreation,
    RomanoNoMountSteelDoubleSlidingDoorHardwaresCreation,
    RomanoNoMountSteelMultiSlidingDoorHardwaresCreation,
    RomanoNoMountSteelFoldingDoorHardwaresCreation,
    RomanoNoMountSteelArchSingleSwingDoorHardwaresCreation,
    RomanoNoMountSteelArchDoubleSwingDoorHardwaresCreation,
    RomanoNoMountNoDoorHardwaresCreation,
    TreviNoMountSteelSingleSwingDoorHardwaresCreation,
    TreviNoMountSteelDoubleSwingDoorHardwaresCreation,
    TreviNoMountSteelSingleSlidingDoorHardwaresCreation,
    TreviNoMountSteelDoubleSlidingDoorHardwaresCreation,
    TreviNoMountSteelMultiSlidingDoorHardwaresCreation,
    TreviNoMountSteelFoldingDoorHardwaresCreation,
    TreviNoMountSteelArchSingleSwingDoorHardwaresCreation,
    TreviNoMountSteelArchDoubleSwingDoorHardwaresCreation,
    TreviNoMountNoDoorHardwaresCreation,
    CGF300PerimeterNoDoorHardwaresCreation,
    CGF350PerimeterNoDoorHardwaresCreation,
    CGF400PerimeterNoDoorHardwaresCreation,
    CGS200PerimeterNoDoorHardwaresCreation,
    KompasCustomXLinesNoDoorHardwaresCreation,
    KompasCustomXLinesSlidingDoorHardwaresCreation,
    KompasCustomXLinesSwingDoorHardwaresCreation,
    KompasFramelessNoDoorHardwaresCreation,
    KompasFramelessSlidingDoorHardwaresCreation,
    KompasFramelessSwingDoorHardwaresCreation,
    KompasPerimeterCGFDoorHardwaresCreation,
    KompasCustomXLinesCGFDoorHardwaresCreation
} from "../domain/strategies/creation/mount-hardwares.strategy";

export class MountHardwareStrategyRegistry {
    private strategies = new Map<string, Constructor<ICreateManyStrategy>>();

    // prettier-ignore
    constructor() {
        // Mount Perimeter Swing Doors
        this.register(CGF300Code, SwingDoors as DoorType[], MountPerimeterCode, CGF300PerimeterSwingDoorHardwaresCreation);
        this.register(CGF350Code, SwingDoors as DoorType[], MountPerimeterCode, CGF350PerimeterSwingDoorHardwaresCreation);
        this.register(CGF400Code, SwingDoors as DoorType[], MountPerimeterCode, CGF400PerimeterSwingDoorHardwaresCreation);
        this.register(CGS200Code, SwingDoors as DoorType[], MountPerimeterCode, CGS200PerimeterSwingDoorHardwaresCreation);

        this.register(KompasDblCode, [CGSSingleSwingDoorCode, CGSDoubleSwingDoorsCode, ...KompasDoors] as DoorType[], MountPerimeterCode, KompasPerimeterSwingDoorHardwaresCreation);
        this.register(KompasSglCode, [CGSSingleSwingDoorCode, CGSDoubleSwingDoorsCode, ...KompasDoors] as DoorType[], MountPerimeterCode, KompasPerimeterSwingDoorHardwaresCreation);


        // Mount Perimeter Sliding Doors
        this.register(CGF300Code, SlidingDoors as DoorType[], MountPerimeterCode, CGF300PerimeterSlidingDoorHardwaresCreation);
        this.register(CGF350Code, SlidingDoors as DoorType[], MountPerimeterCode, CGF350PerimeterSlidingDoorHardwaresCreation);
        this.register(CGF400Code, SlidingDoors as DoorType[], MountPerimeterCode, CGF400PerimeterSlidingDoorHardwaresCreation);
        this.register(CGS200Code, SlidingDoors as DoorType[], MountPerimeterCode, CGS200PerimeterSlidingDoorHardwaresCreation);

        this.register(KompasDblCode, [CGSSingleSlidingDoorCode, CGSDoubleSlidingDoorsCode] as DoorType[], MountPerimeterCode, KompasPerimeterSlidingDoorHardwaresCreation);
        this.register(KompasSglCode, [CGSSingleSlidingDoorCode, CGSDoubleSlidingDoorsCode] as DoorType[], MountPerimeterCode, KompasPerimeterSlidingDoorHardwaresCreation);

        // Kompas Perimeter CGF Doors
        this.register(KompasDblCode, CGFDoors as DoorType[], MountPerimeterCode, KompasPerimeterCGFDoorHardwaresCreation);
        this.register(KompasSglCode, CGFDoors as DoorType[], MountPerimeterCode, KompasPerimeterCGFDoorHardwaresCreation);


        // Mount Perimeter No Doors
        this.register(CGF300Code, NoDoors as DoorType[], MountPerimeterCode, CGF300PerimeterNoDoorHardwaresCreation);
        this.register(CGF350Code, NoDoors as DoorType[], MountPerimeterCode, CGF350PerimeterNoDoorHardwaresCreation);
        this.register(CGF400Code, NoDoors as DoorType[], MountPerimeterCode, CGF400PerimeterNoDoorHardwaresCreation);
        this.register(CGS200Code, NoDoors as DoorType[], MountPerimeterCode, CGS200PerimeterNoDoorHardwaresCreation);
        this.register(KompasDblCode, NoDoors as DoorType[], MountPerimeterCode, KompasPerimeterNoDoorHardwaresCreation);
        this.register(KompasSglCode, NoDoors as DoorType[], MountPerimeterCode, KompasPerimeterNoDoorHardwaresCreation);

        // No mount Romano Doors
        this.register(RomanoCode, [SteelSingleSwingDoorCode] as DoorType[], NoMountCode, RomanoNoMountSteelSingleSwingDoorHardwaresCreation);
        this.register(RomanoCode, [SteelDoubleSwingDoorsCode] as DoorType[], NoMountCode, RomanoNoMountSteelDoubleSwingDoorHardwaresCreation);
        this.register(RomanoCode, [SteelSingleSlidingDoorCode] as DoorType[], NoMountCode, RomanoNoMountSteelSingleSlidingDoorHardwaresCreation);
        this.register(RomanoCode, [SteelDoubleSlidingDoorsCode] as DoorType[], NoMountCode, RomanoNoMountSteelDoubleSlidingDoorHardwaresCreation);
        this.register(RomanoCode, [SteelMultiSlidingDoorsCode] as DoorType[], NoMountCode, RomanoNoMountSteelMultiSlidingDoorHardwaresCreation);
        this.register(RomanoCode, [SteelFoldingDoorsCode] as DoorType[], NoMountCode, RomanoNoMountSteelFoldingDoorHardwaresCreation);
        this.register(RomanoCode, [SteelArchSingleSwingDoorCode] as DoorType[], NoMountCode, RomanoNoMountSteelArchSingleSwingDoorHardwaresCreation);
        this.register(RomanoCode, [SteelArchDoubleSwingDoorsCode] as DoorType[], NoMountCode, RomanoNoMountSteelArchDoubleSwingDoorHardwaresCreation);

        // No mount Trevi Doors
        this.register(TreviCode, [SteelSingleSwingDoorCode] as DoorType[], NoMountCode, TreviNoMountSteelSingleSwingDoorHardwaresCreation);
        this.register(TreviCode, [SteelDoubleSwingDoorsCode] as DoorType[], NoMountCode, TreviNoMountSteelDoubleSwingDoorHardwaresCreation);
        this.register(TreviCode, [SteelSingleSlidingDoorCode] as DoorType[], NoMountCode, TreviNoMountSteelSingleSlidingDoorHardwaresCreation);
        this.register(TreviCode, [SteelDoubleSlidingDoorsCode] as DoorType[], NoMountCode, TreviNoMountSteelDoubleSlidingDoorHardwaresCreation);
        this.register(TreviCode, [SteelMultiSlidingDoorsCode] as DoorType[], NoMountCode, TreviNoMountSteelMultiSlidingDoorHardwaresCreation);
        this.register(TreviCode, [SteelFoldingDoorsCode] as DoorType[], NoMountCode, TreviNoMountSteelFoldingDoorHardwaresCreation);
        this.register(TreviCode, [SteelArchSingleSwingDoorCode] as DoorType[], NoMountCode, TreviNoMountSteelArchSingleSwingDoorHardwaresCreation);
        this.register(TreviCode, [SteelArchDoubleSwingDoorsCode] as DoorType[], NoMountCode, TreviNoMountSteelArchDoubleSwingDoorHardwaresCreation);

        this.register(RomanoCode, NoDoors as DoorType[], NoMountCode, RomanoNoMountNoDoorHardwaresCreation);
        this.register(TreviCode, NoDoors as DoorType[], NoMountCode, TreviNoMountNoDoorHardwaresCreation);

        // Kompas Custom X Lines

        // KOMPAS DOUBLE SYSTEM
        this.register(KompasDblCode, NoDoors as DoorType[], KompasFrameCode, KompasCustomXLinesNoDoorHardwaresCreation);
        // cgs swing doors
        this.register(KompasDblCode, [CGSSingleSwingDoorCode, CGSDoubleSwingDoorsCode, ...KompasDoors] as DoorType[], KompasFrameCode, KompasCustomXLinesSwingDoorHardwaresCreation);
        // cgs sliding doors
        this.register(KompasDblCode, [CGSSingleSlidingDoorCode, CGSDoubleSlidingDoorsCode] as DoorType[], KompasFrameCode, KompasCustomXLinesSlidingDoorHardwaresCreation);
        // cgf doors (swing+sliding)
        this.register(KompasDblCode, CGFDoors as DoorType[], KompasFrameCode, KompasCustomXLinesCGFDoorHardwaresCreation);
        // kompas doors
        this.register(KompasDblCode, KompasDoors as DoorType[], KompasFrameCode, KompasCustomXLinesSwingDoorHardwaresCreation);

        // KOMPAS SINGLE SYSTEM
        this.register(KompasSglCode, NoDoors as DoorType[], KompasFrameCode, KompasCustomXLinesNoDoorHardwaresCreation);
        // cgs swing doors
        this.register(KompasSglCode, [CGSSingleSwingDoorCode, CGSDoubleSwingDoorsCode, ...KompasDoors] as DoorType[], KompasFrameCode, KompasCustomXLinesSwingDoorHardwaresCreation);
        // cgs sliding doors
        this.register(KompasSglCode, [CGSSingleSlidingDoorCode, CGSDoubleSlidingDoorsCode] as DoorType[], KompasFrameCode, KompasCustomXLinesSlidingDoorHardwaresCreation);
        // cgf doors (swing+sliding)
        this.register(KompasSglCode, CGFDoors as DoorType[], KompasFrameCode, KompasCustomXLinesCGFDoorHardwaresCreation);
        // kompas doors
        this.register(KompasSglCode, KompasDoors as DoorType[], KompasFrameCode, KompasCustomXLinesSwingDoorHardwaresCreation);

        // Kompas Frameless
        this.register(KompasDblCode, NoDoors as DoorType[], KompasFramelessCode, KompasFramelessNoDoorHardwaresCreation);
        this.register(KompasDblCode, SwingDoors as DoorType[], KompasFramelessCode, KompasFramelessSwingDoorHardwaresCreation);
        this.register(KompasDblCode, SlidingDoors as DoorType[], KompasFramelessCode, KompasFramelessSlidingDoorHardwaresCreation);

        this.register(KompasSglCode, NoDoors as DoorType[], KompasFramelessCode, KompasFramelessNoDoorHardwaresCreation);
        this.register(KompasSglCode, SwingDoors as DoorType[], KompasFramelessCode, KompasFramelessSwingDoorHardwaresCreation);
        this.register(KompasSglCode, SlidingDoors as DoorType[], KompasFramelessCode, KompasFramelessSlidingDoorHardwaresCreation);
    }

    getStrategy = (
        systemCode: SystemType,
        doorCode: DoorType,
        mountType: MountType,
    ): Constructor<ICreateManyStrategy> | null => {
        const key = this.createKey(systemCode, doorCode, mountType);
        return this.strategies.get(key) || null;
    };

    private register = (
        systemCode: SystemType,
        doorTypes: DoorType[],
        mountType: MountType,
        strategy: Constructor<ICreateManyStrategy>,
    ) => {
        for (const doorType of doorTypes) {
            const key = this.createKey(systemCode, doorType, mountType);
            this.strategies.set(key, strategy);
        }
    };

    /**
     * Creates a unique key by concatenating the provided system code, door type, and mount type.
     *
     * @param systemCode - The code representing the system type.
     * @param doorType - The type of the door.
     * @param mountType - The type of the mount.
     * @returns A string that uniquely identifies the combination of the provided parameters.
     * Example: "cgf300:s-sw:mnt-perimeter".
     */
    private createKey(
        systemCode: SystemType,
        doorType: DoorType,
        mountType: MountType,
    ): string {
        return `${systemCode}:${doorType}:${mountType}`;
    }
}
